import React, { Component, Fragment } from "react";

import SignupForm from "../../containers/SignupForm";

class SignupModal extends Component {
  render() {
    return (
      <Fragment>
        <div className="modal__header">
          <span>{this.props.t("account:inscriptionPageTitle")}</span>
        </div>

        <div className="modal__body">
          <div className="modal__close" onClick={this.props.handleCloseModal}>
            <svg className="bars-icon" viewBox="0 0 24 24">
              <path d="M1,1 L22,22 M1,22 L22,1" stroke="#000" strokeWidth="1" />
            </svg>
          </div>
          <div className="signup-modal">
            <SignupForm handleCancel={this.props.handleCloseModal} t={this.props.t}/>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default SignupModal;



// WEBPACK FOOTER //
// ./src/components/modals/SignupModal.js